exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-blog-index-en-tsx": () => import("./../../../src/pages/blog/index.en.tsx" /* webpackChunkName: "component---src-pages-blog-index-en-tsx" */),
  "component---src-pages-contactus-en-tsx": () => import("./../../../src/pages/contactus.en.tsx" /* webpackChunkName: "component---src-pages-contactus-en-tsx" */),
  "component---src-pages-index-en-tsx": () => import("./../../../src/pages/index.en.tsx" /* webpackChunkName: "component---src-pages-index-en-tsx" */),
  "component---src-templates-blog-tsx": () => import("./../../../src/templates/blog.tsx" /* webpackChunkName: "component---src-templates-blog-tsx" */)
}

